import { TAppState } from '../../types/appState';

export const selectIsContentFullscreenOpen = (state: TAppState) => state.contentFullscreen.isOpen;
